/* ==========================================================================
Modal
========================================================================== */

"use strict";

function initModalsJs() {
  // Functions to open and close a modal
  function openModal($el) {
    $el.classList.add('is-active');
    const navbar = document.querySelector('.navbar-placeholder');
    if (navbar) {
      navbar.style.opacity = '0.5';
    }
  }

  function closeModal($el) {
    $el.classList.remove('is-active');
    const navbar = document.querySelector('.navbar-placeholder');
    if (navbar) {
      navbar.style.opacity = '1';
    }
  }

  function closeAllModals() {
    (document.querySelectorAll('.modal') || []).forEach(($modal) => {
      closeModal($modal);
    });
  }

  // Add a click event on buttons to open a specific modal
  (document.querySelectorAll('.js-modal-trigger') || []).forEach(($trigger) => {
    const modal = $trigger.dataset.target;
    const $target = document.getElementById(modal);

    $trigger.addEventListener('click', () => {
      openModal($target);
    });
  });

  // Add a click event on various child elements to close the parent modal
  (document.querySelectorAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button.close') || []).forEach(($close) => {
    const $target = $close.closest('.modal');

    $close.addEventListener('click', () => {
      closeModal($target);
    });
  });

  // Add a keyboard event to close all modals
  document.addEventListener('keydown', (event) => {
    if (event.key === "Escape") {
      closeAllModals();
    }
  });
}

function modal_open(modalID) {
  $("#" + modalID).toggleClass("is-active");
  $("#" + modalID + " .modal-background").toggleClass("scaleInCircle");
  $("#" + modalID + " .modal-content").toggleClass("scaleIn");
  $("#" + modalID + " .modal-close").toggleClass("is-hidden");
  //Prevent sticky fixed nav and backtotop from overlapping modal
  $("#scrollnav, #backtotop").toggleClass("is-hidden");
  //Prevent body from scrolling when scrolling inside modal
  setTimeout(function () {
    if ($(".dashboard-wrapper").length) {
      $("body").addClass("is-fixed");
    }
  }, 700);
}

function modal_close(modalID) {
  $("#" + modalID + " .modal-background").toggleClass("scaleInCircle");
  $("#" + modalID + " .modal-content").toggleClass("scaleIn");
  $("#" + modalID + " .modal-close").toggleClass("is-hidden");
  //Restore native body scroll
  if ($(".dashboard-wrapper").length) {
    $("body").removeClass("is-fixed");
  }
  setTimeout(function () {
    $(".modal.is-active").removeClass("is-active");
    //Restore sticky nav and backktotop
    $("#scrollnav, #backtotop").toggleClass("is-hidden");
  }, 500);
}

function initModals() {
  //main variable
  var modalID;

  //Triggering a modal
  $(document).on("click", ".modal-trigger", function () {
    modalID = $(this).attr("data-modal");
    modal_open(modalID);
  });

  //Closing a modal
  $(document).on("click", ".modal-close, .modal-dismiss", function () {
    modal_close(modalID);
  });

  //Modal user select toggle
  $(document).on("click", ".modal-card-body .card-select i", function () {
    $(this).toggleClass("is-active");
    $(this).closest(".flex-card").toggleClass("is-active");
    $(".save-btn").removeClass("is-disabled");
  });

  //Modal image gallery with slick carousel
  $(document).on("click", ".modal-trigger.gallery-trigger", function () {
    //Prevents carousel from initiating on a non loaded image
    setTimeout(function () {
      $(".slick-gallery").slick({
        slidesToShow: 1,
        arrows: false,
        dots: true,
        cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1.000)",
        autoplay: true,
        infinite: false,
      });
    }, 100);
  });

  //Success message modal
  if ($("#success-icon").length) {
    var resetSuccess = $("#success-icon svg"); //declare element to reset it at modal close
    //trigger svg animation
    $(document).on("click", ".success-trigger", function () {
      setTimeout(function () {
        new Vivus("success-icon", {
          type: "oneByOne",
          duration: 60,
          delay: 300,
          animTimingFunction: Vivus.EASE_OUT_BOUNCE,
          selfDestroy: true,
          file: "assets/img/graphics/icons/modals/success.svg",
        });
      }, 300);
    });
    //Reset element with initial clone
    $(document).on("click", ".modal-close, .modal-dismiss", function () {
      $("#success-icon svg").replaceWith(resetSuccess);
    });
  }
  //Error message modal
  if ($("#error-icon").length) {
    var resetError = $("#error-icon svg"); //declare element to reset it at modal close
    //trigger svg animation
    $(document).on("click", ".error-trigger", function () {
      setTimeout(function () {
        new Vivus("error-icon", {
          type: "oneByOne",
          duration: 60,
          animTimingFunction: Vivus.EASE_OUT_BOUNCE,
          selfDestroy: true,
          file: "assets/img/graphics/icons/modals/error.svg",
        });
      }, 300);
    });
    //Reset element with initial clone
    $(document).on("click", ".modal-close, .modal-dismiss", function () {
      $("#error-icon svg").replaceWith(resetError);
    });
  }
  //Warning message modal
  if ($("#warning-icon").length) {
    var resetWarning = $("#warning-icon svg"); //declare element to reset it at modal close
    //trigger svg animation
    $(document).on("click", ".warning-trigger", function () {
      setTimeout(function () {
        new Vivus("warning-icon", {
          type: "oneByOne",
          duration: 60,
          animTimingFunction: Vivus.EASE_OUT_BOUNCE,
          selfDestroy: true,
          file: "assets/img/graphics/icons/modals/warning.svg",
        });
      }, 300);
    });
    //Reset element with initial clone
    $(document).on("click", ".modal-close, .modal-dismiss", function () {
      $("#warning-icon svg").replaceWith(resetWarning);
    });
  }
  //Info message modal
  if ($("#info-icon").length) {
    var resetInfo = $("#info-icon svg"); //declare element to reset it at modal close
    //trigger svg animation
    $(document).on("click", ".info-trigger", function () {
      setTimeout(function () {
        new Vivus("info-icon", {
          type: "oneByOne",
          duration: 60,
          animTimingFunction: Vivus.EASE_OUT_BOUNCE,
          selfDestroy: true,
          file: "assets/img/graphics/icons/modals/info.svg",
        });
      }, 1000);
    });
    //Reset element with initial clone
    $(document).on("click", ".modal-close, .modal-dismiss", function () {
      $("#info-icon svg").replaceWith(resetInfo);
    });
  }
}
